import React, {useRef, useState } from 'react';
import Inputs from '../../../Components/Inputs/Inputs';
import {useTranslation} from 'react-i18next';
import Wrp from '../../../hoc/Wrp/Wrp';
import AvatarImageUpload from '../../../Components/UI/AvatarImageUpload';
import PhoneNumberField from '../../../Components/PhoneNumberField';
import Icons from '../../../Components/Icons/Icons';

const AdduserForm = props => {
    const [copied, setCopied] = useState(false);

    const fieldDetail = JSON.parse(props.formData);	
    const {t} = useTranslation();
    const uploadImageFilesRef = useRef(null);
    // console.log(fieldDetail);
    const handleCopy = async (apiKey) => {
        try {
          await navigator.clipboard.writeText(apiKey);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
        } catch (err) {
          console.error("Failed to copy!", err);
        }
      };
    return(
        <div className="card-body">
            <div className="row">
            <div className="col-12">
                <div className="mb-0">
                {(props.addFromDVpage===false)?
                    <div className="border-bottom p-2">
                    { props.show === 'edituser' ?
                        <div className="card-title d-flex text-large">{ fieldDetail.isOrg.value === false && fieldDetail.isSystemUser.value === false ? 'Activate/Inactivate' : 'Edit User' }
                        { fieldDetail.isOrg.value === false && fieldDetail.isSystemUser.value === false ?
                            <div className="material-switch pl-4">
                                <input 
                                    id={"window-id"+fieldDetail.userId.value} name="Windows"
                                    type="checkbox" 
                                    onChange={e=>props.toggleUserStatus(e,fieldDetail.userId.value)}
                                    checked={(fieldDetail.isActive.value === 'true' || fieldDetail.isActive.value === true) ? true : false}
                                />
                                <label htmlFor={"window-id"+fieldDetail.userId.value}className="secondary_bg"></label>
                            </div> : null
                        }
                        </div>
                        :
                        <div className="card-title text-large">Add User</div>
                    }
                    </div>
                :''}
                    <div className={(props.addFromDVpage===false)?'card-body':''}>  
                        <div className="border-bottom mb-3">
                            <div className="card-title"> Login Information </div>
                        </div>

                        <div className="row">
                            {props.show === 'edituser'?
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="form-group row">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Username">{t("Username")}</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="email" formData={JSON.stringify(fieldDetail.username)} />
                                    </div>
                                </div>
                            </div> 
                            : null }
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.email.error !== "" ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title=" ">{t("E-mail")}</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="email" formData={JSON.stringify(fieldDetail.email)} changed={props.changed}/>
                                        {fieldDetail.email.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.email.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div> 
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.password.isError === true ? "form-group row position-relative has-error" : "form-group row position-relative" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title=" ">Password</label>
                                    
                                    {props.show === 'adduser'?
                                    <div className="view-password" onClick={() => props.passwordViewHandler("adduser","password")}>
                                        <i className={fieldDetail.password.passwordShow ? 'far fa-eye-slash' : 'far fa-eye'}></i>
                                    </div> 
                                    : fieldDetail.password.disabled !== true ? 
                                    <div className="view-password" onClick={() => props.revokePassword("adduser","password")}>
                                        <Icons iconType="Remove" />
                                    </div>
                                    : <div className="view-password" onClick={() => props.revokePassword("adduser","password")}>
                                        <i className='far fa-exchange-alt' title="Revoke"></i>
                                    </div>}
                                     

                                    <div className="col-lg-9 col-md-9 col-sm-8">                                    
                                        <Inputs fieldName="password" formData={JSON.stringify(fieldDetail.password)} changed={props.changed}/>
                                        {fieldDetail.password.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.password.error}</label>
                                            : null
                                        }
                                    </div>                                    
                                </div>

                                {
                                    props.show === 'adduser' || fieldDetail.password.disabled !== true ?                                     
                                    <div className="form-group form-action-d-flex" style={{marginLeft:'0rem'}}>
                                        <div className="pass_Alert">
                                            <small className={props.passwordRule.lowercase ? "text-success p-1" : "text-danger p-1"}><i className={props.passwordRule.lowercase ? "fas fa-check" : "fas fa-times"}></i> one lowercase character </small>
                                            <small className={props.passwordRule.uppercase ? "text-success p-1" : "text-danger p-1"}><i className={props.passwordRule.uppercase ? "fas fa-check" : "fas fa-times"}></i> one uppercase character </small>
                                            <small className={props.passwordRule.specialChar ? "text-success p-1" : "text-danger p-1"}><i className={props.passwordRule.specialChar ? "fas fa-check" : "fas fa-times"}></i> one special character </small>
                                         
                                            <small className={props.passwordRule.numeric ? "text-success p-1" : "text-danger p-1"}><i className={props.passwordRule.numeric ? "fas fa-check" : "fas fa-times"}></i> one number </small>
                                            <small className={props.passwordRule.minChar ? "text-success p-1" : "text-danger p-1"}><i className={props.passwordRule.minChar ? "fas fa-check" : "fas fa-times"}></i> 8 characters minimum </small>
                                        </div>
                                    </div>                                    
                                    : 
                                    <></>
                                } 
                            </div>                                                    
                        </div>


                        <div className="border-bottom mb-3">
                            <div className="card-title"> User Information </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-xl-4 col-12">
                                {/*<div className="form-group row has-error">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="First Name">{t("firstname")}</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="fname" formData={JSON.stringify(fieldDetail.fname)} changed={props.changed}/>                                       
                                        <label className="error m-0">This field is required.</label>
                                    </div>
                                </div>*/}
                                <div className={fieldDetail.firstName.error !== "" ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="First Name">{t("firstname")}</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="firstName" formData={JSON.stringify(fieldDetail.firstName)} changed={props.changed}/>
                                        {fieldDetail.firstName.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.firstName.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.lastName.error !== "" ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Last Name">Last Name</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="lastName" formData={JSON.stringify(fieldDetail.lastName)} changed={props.changed}/>
                                        {fieldDetail.lastName.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.lastName.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            

                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.work_number.error !== "" ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Work Number">Work Number</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <PhoneNumberField
                                            name="work_number"
                                            changeHandler={props.changed}
                                            className={fieldDetail.work_number.classname}
                                            placeholder={fieldDetail.work_number.placeHolder}
                                            value={fieldDetail.work_number.value}
                                        />
                                        {/*<Inputs fieldName="work_number" formData={JSON.stringify(fieldDetail.work_number)} changed={props.changed}/>*/}
                                        {fieldDetail.work_number.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.work_number.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.mobile_number.error !== "" ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Mobile Number">Mobile Number</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <PhoneNumberField
                                            name="mobile_number"
                                            changeHandler={props.changed}
                                            className={fieldDetail.mobile_number.classname}
                                            placeholder={fieldDetail.mobile_number.placeHolder}
                                            value={fieldDetail.mobile_number.value}
                                        />
                                        {/*<Inputs fieldName="mobile_number" formData={JSON.stringify(fieldDetail.mobile_number)} changed={props.changed}/>*/}
                                        {fieldDetail.mobile_number.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.mobile_number.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            
                            {/*<div className="col-3">
                                <div className="form-group ">
                                    <label htmlFor="inlineinput" className="pl-0">TimeZone</label>
                                    <Inputs fieldName="timeZone" formData={JSON.stringify(fieldDetail.timeZone)} changed={props.changed}/>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="inlineinput" className="pl-0">Language</label>
                                    <Inputs fieldName="language" formData={JSON.stringify(fieldDetail.language)} changed={props.changed}/>
                                </div>
                            </div>     
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="inlineinput" className="pl-0">Locale</label>
                                    <Inputs fieldName="locale" formData={JSON.stringify(fieldDetail.locale)} changed={props.changed}/>
                                </div>
                            </div> 
                            <div className="col-3">
                                <div className="form-group ">
                                    <label htmlFor="inlineinput" className="pl-0">DateFormat</label>
                                    <Inputs fieldName="dateformat" formData={JSON.stringify(fieldDetail.dateformat)} changed={props.changed}/>
                                </div>
                            </div>*/}

                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.role.error !== "" || fieldDetail.role.isError ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Role">Role</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        {/*<Inputs fieldName="role" formData={JSON.stringify(fieldDetail.role)} changed={props.changed}/>*/}
                                        {/*<div className="mandatory">*/}
                                            <Inputs fieldName="role" formData={JSON.stringify(fieldDetail.role)} changed={props.select2Changed}/>
                                        {/*</div>*/}
                                        {fieldDetail.role.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.role.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.profile.error !== "" || fieldDetail.profile.isError? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Profile">Profile</label>
                                     <div className="col-lg-9 col-md-9 col-sm-8">
                                        {/*<Inputs fieldName="profile" formData={JSON.stringify(fieldDetail.profile)} changed={props.changed}/>*/}
                                        <Inputs fieldName="profile" formData={JSON.stringify(fieldDetail.profile)} changed={props.select2Changed}/>
                                        {fieldDetail.profile.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.profile.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>   
                            
                            
                            
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className={fieldDetail.description.error !== "" ? "form-group row has-error" : "form-group row" }>
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Description">Description</label>
                                     <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="description" formData={JSON.stringify(fieldDetail.description)} changed={props.changed}/>
                                        {fieldDetail.description.error !== "" ? 
                                            <label className="error m-0">{fieldDetail.description.error}</label>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="form-group row">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="API User">Is API User</label>
                                    <div className="col-lg-9 col-md-9 col-sm-8">
                                        <div className="material-switch mt-3">
                                            <input 
                                                id={"window-id"+fieldDetail.is_api_user.value} name="is_api_user"
                                                type="checkbox" 
                                                onChange={e=>{console.log(e.target.checked);props.changed({target:{name:e.target.name,value:Boolean(e.target.checked)}})}}
                                                checked={(fieldDetail.is_api_user.value === 'true' || fieldDetail.is_api_user.value === true) ? true : false}
                                            />
                                            <label htmlFor={"window-id"+fieldDetail.is_api_user.value}className="secondary_bg"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        {fieldDetail.is_api_user.value===true &&
                        <Wrp>
                        <div className="border-bottom mb-3">
                            <div className="card-title"> API Information </div>
                        </div>
                            <div className="row">
                                <div className="col-md-6 col-xl-4 col-12">
                                    <div className="form-group row">
                                        <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="API Key">API Key</label>
                                        <div className="col-lg-9 col-md-9 col-sm-8">
                                           {/* <input type="text" value={fieldDetail.api_key.value} class="form-control input-full" readOnly={true} /> */}
                                           <div class="input-group">
                                           <div className='input-group-prepend'>
                                                <button class="input-group-text primary_bg cursor_pointer" type="button" onClick={()=>handleCopy(fieldDetail.api_key.value)} title="Copy">
                                                <i class="fas fa-copy" style={{color:'#fff'}}></i>
                                                </button>
                                                {copied && (
                                                    <span className="ml-2" style={{
                                                        whiteSpace: "nowrap",
                                                        position: "absolute",
                                                        top: "-30px",
                                                        left: "10px",
                                                        background: "#000",
                                                        color: "#fff",
                                                        zIndex: 99,
                                                        padding: "2px 6px",
                                                        borderRadius: "3px",
                                                        fontSize: "12px",
                                                        opacity: copied ? 1 : 0,
                                                        transition: "opacity 0.3s ease-in-out",
                                                        pointerEvents: "none"
                                                      }}>
                                                    Copied!
                                                    </span>
                                                )}
                                           </div>
                                            <input
                                                type="text"
                                                value={fieldDetail.api_key.value}
                                                class="form-control input-full"
                                                id="apiKeyInput"
                                                readonly
                                                disabled={true}
                                            />
                                            <div class="input-group-append">
                                               
                                                <button class="btn btn-outline-secondary bl-1" type="button" onClick={props.generateNewTokenAPI} title="Refresh">
                                                <i class="fas fa-sync-alt" style={{color:'#fff'}}></i>
                                                </button>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                        
                        </Wrp>
                        }


                        { //props.show === 'edituser' ?
                        <Wrp>
                        <div className="border-bottom mb-3">
                            <div className="card-title"> Locale Information </div>
                        </div>
                        <div className="row">

                            
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="form-group row">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Time Zone">Time Zone</label>
                                     <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="timeZone" formData={JSON.stringify(fieldDetail.timeZone)} changed={props.select2Changed}/>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="form-group row">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Language">Language</label>
                                     <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="language" formData={JSON.stringify(fieldDetail.language)} changed={props.select2Changed}/>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="form-group row">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Locale">Locale</label>
                                     <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="locale" formData={JSON.stringify(fieldDetail.locale)} changed={props.select2Changed}/>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="form-group row">
                                    <label className="col-lg-3 col-md-3 col-sm-4 text-truncate" title="Date Format">Date Format</label>
                                     <div className="col-lg-9 col-md-9 col-sm-8">
                                        <Inputs fieldName="dateformat" formData={JSON.stringify(fieldDetail.dateformat)} changed={props.select2Changed}/>
                                    </div>
                                </div>
                            </div>  
                            
                        </div>
                        </Wrp>
                        //: null
                        }

                        <div className="border-bottom mb-3">
                            <div className="card-title"> Profile </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-xl-4 col-12">
                                <div className="card card-profile no-box-shadow bg-transparent">
                                    <div className="bg-transparent">
                                        <div className="profile-picture">
                                            <div className="form-group">
                                                <label> Profile Image </label>
                                                <AvatarImageUpload 
                                                    uploadFileRef={uploadImageFilesRef}
                                                    fileClickHandler={props.uploadImageFiles}
                                                    removeHandler={props.removeAvatarImage}
                                                    fileChangeHandler={props.onFileChange}
                                                    imageId={fieldDetail.profile_avatar.value} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    {
                        props.validationError.length > 0  ? 
                        <div className="alert alert-danger" role="alert">
                        {
                            props.validationError.map((arr,i)=> {
                                return <p key={i}>{arr}</p>
                            })
                        }
                        </div> : null
                    }
                </div>
            </div>
            </div>
        </div>
    );
    
}

export default AdduserForm;